import script from "./LoadingCh.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingCh.vue?vue&type=script&setup=true&lang=js"

import "./LoadingCh.vue?vue&type=style&index=0&id=e3d06554&lang=scss"

const __exports__ = script;

export default __exports__